<div class="card-content">
    <slot/>
</div>

<style>
.card-content {    
    padding-left: var(--card-content-h-padding);
    padding-right: var(--card-content-h-padding);
}

.card-content:first-child {
    margin-top: 0;
    padding-top: 0;
}

.card-content:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
}
</style>